import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { PublicRoute } from './components/PublicRoute';
import Layout from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { KnowledgeBasePage } from './pages/KnowledgeBasePage';
import { BugDetailPage } from './pages/BugDetailPage';
import { TicketDetailPage } from './pages/TicketDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { LoginPage } from './pages/LoginPage';
import { VerifyPage } from './pages/VerifyPage';
import { OAuthCallbackPage } from './pages/OAuthCallbackPage';
import { ErrorPage } from './pages/ErrorPage';


function App() {
  return (
    <Routes>
      {/* Public routes */}
        <Route element={<PublicRoute />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/verify" element={<VerifyPage />} />
            <Route path="/auth/callback" element={<OAuthCallbackPage />} />
        </Route>
      {/* Protected routes with Layout */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:id" element={<ProjectDetailPage />} />
        <Route path="/projects/:id/knowledge" element={<KnowledgeBasePage />} />
        <Route path="/projects/:projectId/bugs/:taskId" element={<BugDetailPage />} />
        <Route path="/projects/:projectId/tickets/:ticketKey" element={<TicketDetailPage />} />
        <Route
          path="/settings"
          element={
            <ProtectedRoute requireAdmin>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
      </Route>

      {/* Default redirect and 404 */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<ErrorPage code={404} />} />
    </Routes>
  );
}

export default App;
